export const CATEGORIES_ACTION_TYPES = {
    SET_CATEGORIES_MAP: 'category/SET_CATEGORIES_MAP',
};